import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "reset-pass-modal",
  props: ["value", "title", "id"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      data: {
        pass: ''
      },
      rules: {
        pass: {
          type: "string",
          required: true
        }
      },
      loading: false
    };
  },
  methods: {
    onLoad: function onLoad() {
      this.validate();
    },
    handleOk: function handleOk() {
      var _this = this;
      var data = {
        "new-password": this.data.pass
      };
      this.loading = true;
      return Axios.put("users/".concat(this.id, "/reset-password/"), data).then(function (resp) {
        var _resp$data = resp.data,
          code = _resp$data.code,
          data = _resp$data.data;
        if (code === 0) {
          _this.$Message.success('密码重置成功！');
          _this.modalVisible = false;
          _this.$emit('close', true);
          return false;
        }
        _this.$Message.console.error('密码重置失败！');
      }).catch(function (err) {
        console.log(err);
        _this.$Message.console.error('密码重置失败！');
      }).finally(function () {
        _this.loading = false;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
    }
  }
};